// extracted by mini-css-extract-plugin
export default {"errorPage":"style_errorPage__x49WF","errorTitle":"style_errorTitle__2c60T","errorMessage":"style_errorMessage__CCmk0"};